module.exports = __webpack_public_path__ + "media/components/signup-page/static/icon-back-6a376de40569fd3e11ee316753eec491.svg";